import Roles from '@/items/Roles';
import { Model } from '@/models/Model';
import { Auth } from '@/support/Auth';
export class GlobalUser extends Model {
    constructor() {
        super(...arguments);
        this.$endpoint = '/global-users';
        this.$name = 'GlobalUser';
        this.$fillable = [
            'avatar',
            'email',
            'first_name',
            'middle_name',
            'last_name',
            'roles',
        ];
        //#endregion
    }
    //#region relationship methods
    //#endregion
    //#region Endpoints
    //#endregion
    //#region Class methods
    hasValidMfa() {
        return !this.mfa_required || !!this.has_mfa_token;
    }
    hasRole(roles) {
        if (!this.roles) {
            return false;
        }
        if (typeof roles === 'string') {
            roles = [roles];
        }
        return this.roles.some((role) => roles.includes(role.id));
    }
    isSameAs(user) {
        // Bad bad bad...
        return this.email === user.email;
    }
    impersonate() {
        if (!(this.token)) {
            return;
        }
        Auth.loginAs(this.token.bearer);
    }
    authenticate() {
        const url = '/global-users/global-authentication';
        return this.request('post', url);
    }
    //#endregion
    //#region Getters & Setters
    get rolesLabel() {
        if (!this.roles) {
            return '';
        }
        if (Array.isArray(this.roles)) {
            return this.roles
                .map((role) => Roles.texts[role.id])
                .join(', ')
                .replace(/, ([^,]*)$/, ' and $1');
        }
        return Roles.texts[this.roles];
    }
}
//#region Includes enum
export var GlobalUserIncludes;
(function (GlobalUserIncludes) {
    GlobalUserIncludes["TOKEN"] = "token";
    GlobalUserIncludes["SCHOOLS"] = "schools";
})(GlobalUserIncludes || (GlobalUserIncludes = {}));
//#endregion
